<template>
  <div class="ivy-player-container">
    <button
      v-if="!playing && playOnce"
      class="ivy-btn-play"
      @click.stop="play"
    ></button>
    <div v-if="!playOnce" class="ivy-video-poster">
      <div v-if="showMask" class="mark"></div>
      <img class="ivy-video-poster-inner" :src="poster" alt="" />
      <button class="ivy-btn-play" @click.stop="play"></button>
    </div>
    <video
      ref="media"
      class="ivy-media"
      :src="src"
      :poster="poster"
      preload="meta"
      width="100%"
      height="100%"
      controls
      controlslist="nodownload"
      :loop="loop"
      style=""
      :muted="muted"
      :webkit-playsinline="notFullscreen"
      :playsinline="notFullscreen"
      @timeupdate="timeupdate"
    ></video>
    <!-- webkit-playsinline="true"
   style="object-fit:fill"
  x-webkit-airplay="allow"
  x5-video-orientation="landscape|portrait"
  playsinline="true"
  x5-video-player-type="h5"
  x5-video-player-fullscreen="true" landscape|portrait -->
    <div v-if="ipad || isMix2s" class="ivy-media-controls">
      <button v-if="!playing" class="btn-play" @click="play">&#xe629;</button>
      <button v-else class="btn-pause" @click="pause">&#xe64b;</button>
      <div class="media-updatetime">
        {{ Date.formatMs(currentTime * 1000, 'mm:ss') || '00:00' }}
      </div>
      <div class="media-progress">
        <vueSlider
          ref="slider"
          v-model="slider.curValue"
          class="progress"
          tooltip
          :height="slider.height"
          :dot-size="slider.dotSize"
          :bg-style="slider.bgStyle"
          :process-style="slider.processStyle"
          :slider-style="slider.sliderStyle"
          @callback="changeSlider($event)"
        />
      </div>
      <div class="media-time">
        {{ Date.formatMs(duration * 1000, 'mm:ss') || '00:00' }}
      </div>
      <!-- <button class="btn-full" v-if="ipad && !full" @click="requestFullscreen">&#xe7f7;</button>
    <button class="btn-exitfull" v-if="ipad && full" @click="cancelFullscreen">&#xe60d;</button> -->
    </div>
  </div>
</template>
<script>
import vueSlider from 'vue-slider-component'
import { sleep, isWeixin, getOs, isIos } from '@ivy/fts/utils'
export default {
  components: { vueSlider },
  props: {
    src: {
      type: String,
      default: '',
    },
    poster: {
      type: String,
      default: '',
    },
    loop: {
      type: Boolean,
      default: false,
    },
    isRichText: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    notFullscreen: {
      type: Boolean,
      default: false,
    },
    showMask: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ipad: false,
      isMix2s: false,
      full: false,
      dir: 'horizontal', // 屏幕方向
      container: null,
      playing: false, // 是否正在播放
      playOnce: false,
      duration: 0,
      currentTime: 0,
      slider: {
        // 控制进度条部分
        // direction: this.ios && this.full ? 'vertical' : 'horizontal',
        curValue: 1,
        height: 2,
        dotSize: 14,
        bgStyle: {
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          height: '2px',
        },
        processStyle: {
          backgroundColor: '#da277c',
        },
        sliderStyle: {
          backgroundColor: '#da277c',
          boxShadow: 'none',
        },
      },
    }
  },
  watch: {
    currentTime(val) {
      let percentage = (val / this.duration).toFixed(2)
      let list = [0.1, 0.3, 0.5, 0.8]
      if (list.findIndex(i => i == percentage) > -1) {
        this.$emit('point', val, percentage)
      }
    },
  },
  async mounted() {
    let ua = navigator.userAgent.toLowerCase()
    this.ipad = ua.match(/iPad/i) === 'ipad' || window.innerWidth >= 768
    this.isMix2s =
      ua.includes('mix') ||
      ua.includes('mix 2s') ||
      ua.includes('MIX 2S') ||
      ua.includes('10.2')
    this.container = document.querySelector('.ivy-player-container')
    // 设置音量大小为0.5
    // x5-video-orientation=landscape|portrait 横屏|竖屏 根据系统自动旋转
    // this.media.volume = 0.5
    // this.$refs.media.addEventListener('loadedmetadata' ,() => {
    //   this.playing = false
    // })
    let videoEl = this.$el.querySelector('.ivy-media')
    this.$refs.media.addEventListener('play', () => {
      this.playing = true
      this.playOnce = true
      this.$emit('on-play')
    })
    this.$refs.media.addEventListener('pause', ev => {
      if (isIos()) {
        setTimeout(() => {
          if (videoEl.seeking) {
            return
          }
          this.playing = false
          this.$emit('on-pause')
          this.$emit('close', this.currentTime)
        }, 100)
      } else {
        if (videoEl.seeking) {
          return
        }
        this.playing = false
        this.$emit('on-pause')
        this.$emit('close', this.currentTime)
      }
    })
    // videoEl.addEventListener('seeking', function(e) {
    //   console.log('开始移动进度条')
    // })
    // videoEl.addEventListener('seeked', ev => {
    //   console.log('进度条已经移动到了新的位置')
    // })
    this.$refs.media.addEventListener('stop', () => {
      this.playing = false
      this.$emit('on-stop', this.currentTime)
    })
    this.$refs.media.addEventListener('ended', async () => {
      console.log('playend')
      this.$emit('on-playend', this.currentTime)
      this.playing = false
      this.exitFullscreen(this.$refs.media)
    })
    let evt = 'onorientationchange' in window ? 'orientationchange' : 'resize'
    // window.addEventListener(evt, () => {
    //   // 暂时先退出全屏
    //   return this.cancelFullscreen()
    //   if (this.ios && this.playing) {
    //     if (window.orientation == 180 || window.orientation == 0) {
    //       this.$Toast('已开启竖屏')
    //       this.dir = 'horizontal'
    //       return this.iosFullscreen()
    //     }
    //     if (window.orientation == 90 || window.orientation == -90) {
    //       this.$Toast('已开启横屏')
    //       this.dir = 'vertical'
    //       return this.iosFullscreen()
    //     }
    //   }ƒ
    // })
    let opt = {
      proload: 'auto',
      'x-webkit-airplay': 'allow',
      'x5-video-player-type': 'h5',
      'x5-video-player-fullscreen': true,
      'x5-video-orientation': 'portraint',
      'webkit-playsinline': true,
      playsinline: true,
      style: 'object-fit:fill;position:absolute',
    }
  },
  methods: {
    exitFullscreen(videoBoj) {
      if (!videoBoj) {
        return
      }
      getOs() === 'android'
        ? this.isRichText
          ? (() => {})()
          : '(videoBoj.srcObject = new window.webkitMediaStream())'
        : videoBoj.webkitExitFullScreen()
    },
    async toggleControls() {
      this.controlsHide = !this.controlsHide
    },
    setElementAttr(ele, option) {
      for (let key in option) {
        if (ele) {
          ele.setAttribute(key, option[key])
        }
      }
      return ele
    },
    async play() {
      //目前仍有需要从外部调用play方法的位置，请查清后再调整本方法
      this.$emit('play')
      this.playOnce = true
      let playFn = () => {
        // this.iosFullscreen()
        let playPromise = this.$refs.media.play()
        // this.requestFullscreen(this.media)
        if (playPromise !== undefined) {
          playPromise.catch(error => {}).then(() => {})
        }
      }
      if (isWeixin()) {
        document.addEventListener('WeixinJSBridgeReady', playFn(), false)
      } else {
        console.log('is chrome')
        playFn()
      }
    },
    pause() {
      this.$refs.media.pause()
      // this.playing = false
    },
    timeupdate(ev) {
      this.duration = ev.target.duration
      this.currentTime = ev.target.currentTime
      this.slider.curValue = Math.floor(
        (this.currentTime / this.duration) * 100
      )
      if (+this.slider.curValue % 5 === 0) {
        this.$emit('playTimeUpdate', this.slider.curValue)
      }
    },
    changeSlider(ev) {
      let pos = Math.floor(this.duration / (100 / ev))
      this.$refs.media.currentTime = pos
    },
    async iosFullscreen() {
      // dir为vertical是横屏 为horizontal是竖屏 默认是horizontal竖屏
      if (this.ios) {
        let width = window.innerWidth
        let height = window.innerHeight
        let element = this.container
        element.style.position = 'fixed'
        element.style.zIndex = '999'
        if (width > height) {
          element.style.transform =
            this.dir === 'horizontal' ? 'rotate(90deg)' : 'rotate(0deg)'
          element.style.width = `${width}px`
          element.style.height = `${height}px`
          element.style.top =
            this.dir === 'horizontal' ? `${(width - height) / 2}px` : '0px'
          element.style.left =
            this.dir === 'horizontal' ? `${(height - width) / 2}px` : '0px'
        } else {
          element.style.transform =
            this.dir === 'vertical' ? 'rotate(0deg)' : 'rotate(90deg)'
          element.style.width = `${height}px`
          element.style.height = `${width}px`
          element.style.top =
            this.dir === 'vertical' ? '0px' : `${(height - width) / 2}px`
          element.style.left =
            this.dir === 'vertical' ? '0px' : `${(width - height) / 2}px`
        }
        this.full = true
      }
    },
    async requestFullscreen(elem = this.$refs.media) {
      await this.$nextTick()
      // if (this.ios) {
      this.full = true
      //   return this.iosFullscreen()
      // }
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen()
      }
    },
    async cancelFullscreen() {
      await this.$nextTick()
      // if (this.ios) {
      this.full = false
      //   return this.container.removeAttribute('style')
      // }
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.oRequestFullscreen) {
        document.oCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
  },
}
</script>
<style lang="less">
@import (reference) url(../project.less);
@font-face {
  font-family: 'iconfontPlayer'; /* project id 753392 */
  src: url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.eot');
  src: url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.eot?#iefix')
      format('embedded-opentype'),
    url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.woff') format('woff'),
    url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_753392_8xd7ow9qyac.svg#iconfont') format('svg');
}
.iconfontPlayer {
  font-family: 'iconfontPlayer' !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.tranAnimate(@ms: 0.2s) {
  transition-duration: @ms;
  -webkit-transition-duration: @ms;
  -moz-transition-duration: @ms;
  -o-transition-duration: @ms;
}
.ivy-player-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  .tranAnimate(0.2s);
  .ivy-btn-play,
  .ivy-btn-pause {
    .iconfontPlayer;
    .image-cover;
    position: absolute;
    border-radius: 50%;
    width: 106px;
    height: 106px;
    font-size: 40px;
    left: 50%;
    top: 50%;
    margin-left: -53px;
    margin-top: -53px;
    z-index: 10;
    &.ivy-btn-play {
      // background-image: url(../assets/icon/icon-player.png);
    }
  }
  .ivy-video-poster {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    .mark {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.2);
      z-index: 1;
      position: absolute;
      left: 0;
      top: 0;
    }
    .ivy-video-poster-inner {
      width: 101%;
    }
    .ivy-btn-play {
      border-radius: 50%;
      width: 106px;
      height: 106px;
    }
  }
  video::-webkit-media-controls {
    overflow: hidden !important;
  }
  // video::-webkit-media-controls-enclosure {
  //   width: calc(100% + 111px);
  //   margin-left: auto;
  // }
  .ivy-media {
    width: 100%;
    height: 100%;
  }
  .ivy-media-controls {
    display: none !important;
    transform: rotate(0);
    position: absolute;
    height: 66px;
    background-color: rgba(0, 0, 0, 0.6);
    left: 0;
    right: 0;
    bottom: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    align-items: center;
    .btn-play,
    .btn-pause,
    .btn-full,
    .btn-exitfull {
      .iconfontPlayer;
      width: 66px;
      height: 66px;
      font-size: 32px;
    }
    .media-updatetime,
    .media-time {
      height: 66px;
      font: 18px/66px Arial, Helvetica, sans-serif;
      color: #fff;
      width: 70px;
      text-align: center;
    }
    .media-progress {
      flex: 1;
    }
  }
}
// @media screen and (min-width: 768px) {
//   .ivy-player-container{
//     height: 187px;
//     .ivy-btn-play, .ivy-btn-pause{
//       width: 53px;
//       height: 53px;
//       font-size: 20px;
//       margin-left: -26.5px;
//       margin-top: -26.5px;
//     }
//     .ivy-media-controls{
//       height: 33px;
//       .btn-play, .btn-pause, .btn-full, .btn-exitfull{
//         width: 33px;
//         height: 33px;
//         font-size: 16px;
//       }
//       .media-updatetime, .media-time{
//         height: 33px;
//         font: 9px/33px Arial,Helvetica,sans-serif;
//         width: 35px;
//       }
//     }
//   }
// }
</style>
<style lang="less" scoped>
button {
  color: #fff;
}
</style>
